jQuery(function ($) {
  if ($(".second-header__navigation--mobile").length) {
    // These steps will trigger the hooks necessary for the parent theme to work
    // with mobile menu toggle
    $(window).on("elementor/frontend/init", function () {
      elementorFrontend.hooks.doAction(
        "frontend/element_ready/imenu_mobile.default"
      );
    });
  }
});
